import { getBranding } from '@/service/api';
import { getBrandingLogos } from '@/service/api';
import { getBrandingInfo } from '@/service/api'
import { FETCH_EVENT_BRANDING_SUCCESS } from '@/store/actions';
import { FETCH_EVENT_BRANDING_INFO_SUCCESS } from '@/store/actions';
import { FETCH_EVENT_BRANDING_LOGOS_SUCCESS } from '@/store/actions';
import { FETCH_EVENT_BRANDING_LOGOS_FETCH_LOADING_SUCCESS } from '@/store/actions';
import { commitLocalAndToGlobalService } from '@/utils/vuex';
import Constants from '@/utils/constants';

export const BrandingModule = {
  namespaced: true,
  state: () => ({
    eventBranding: '',
    eventBrandingLogosFetched: false,
    brandingInfo: null,
    eventBrandingLogos: [],
    allEventBrandingLogos: [],
  }),
  getters: {
    hasEventBranding: state => state.eventBranding != '',
    hasBrandingLogo: state => state.eventBrandingLogos.findIndex(l => l.BrandingGroupItem != null) !== -1,
    getBrandingInfo: state => state.brandingInfo,
    getBrandingLogosFetched: state => state.eventBrandingLogosFetched,
    getBrandingLogos: state => state.eventBrandingLogos,
    getAllBrandingLogos: state => state.allEventBrandingLogos,
  },
  mutations: {
    [FETCH_EVENT_BRANDING_SUCCESS]: (state, branding) => {
      state.eventBranding = branding;
    },
    [FETCH_EVENT_BRANDING_LOGOS_SUCCESS]: (state, brandingLogos) => {
      state.eventBrandingLogos = brandingLogos;
    },
    [FETCH_EVENT_BRANDING_INFO_SUCCESS]: (state,brandingInfo) => {
      state.brandingInfo = brandingInfo;
    },
    [FETCH_EVENT_BRANDING_LOGOS_FETCH_LOADING_SUCCESS]: (state, isBrandingLogoFetchComplete) => {
      state.eventBrandingLogosFetched = isBrandingLogoFetchComplete;
    },
  },
  actions: {
    getEventBrandingInfo: async ({ commit }, brandingGuid) => {
      try {
        if (!brandingGuid) {
          return;
        }
        const result = await getBrandingInfo(brandingGuid);
        commitLocalAndToGlobalService(commit, FETCH_EVENT_BRANDING_INFO_SUCCESS, result.data);
      } catch (err) {
          console.error(err); 
      }
  },
    getEventBranding: async ({ commit }, brandingGuid) => {
        try {
          if (!brandingGuid) {
            return;
          }
          const result = await getBranding(brandingGuid, Constants.ApplicationId);
          const brandingString = result.data;
          if (brandingString !== '') {
              const sheet = document.styleSheets[0];
              sheet.insertRule(brandingString);
          }
          commitLocalAndToGlobalService(commit, FETCH_EVENT_BRANDING_SUCCESS, brandingString);
        } catch (err) {
            console.error(err); 
        }
    },
    getEventBrandingLogos: async ({ commit, state }, presId) => {
      try {
          const result = await getBrandingLogos(presId);
          let brandingLogos = [];
          if (result.data != null && result.data.length) {
            brandingLogos = result.data;
            state.allEventBrandingLogos = brandingLogos;
            brandingLogos = brandingLogos.filter(l => l.BrandingGroupItem !== null && (l.BrandingGroupItem.LogoType & (Constants.BrandingLogoTypes.Issuer | Constants.BrandingLogoTypes.Registration)) !== 0);
          }
          commitLocalAndToGlobalService(commit, FETCH_EVENT_BRANDING_LOGOS_SUCCESS, brandingLogos);
      } catch (err) {
          console.error(err);
      }
      commitLocalAndToGlobalService(commit, FETCH_EVENT_BRANDING_LOGOS_FETCH_LOADING_SUCCESS, true);
    },
  },
};
